/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuildingHeaderParRequestDto } from './buildingHeaderParRequestDto.model';


/**
 * Daňová data budovy k uložení
 */
export interface BuildingHeaderRequestDto { 
    /**
     * Seznam osvobození budovy na úrovni jednotlivých parcel. Každá položka obsahuje data o osvobození pro konkrétní kombinaci parcela-budova a zastavěnou výměru parcely.
     */
    buildingHeaderPar?: Array<BuildingHeaderParRequestDto>;
    /**
     * Předmět daně ze staveb a jednotek - druh zdanitelné stavby (typ H-P pro stavby, R-Z pro jednotky). Povinné pole pro daňové přiznání.
     */
    kstavby: string;
    /**
     * Počet dalších nadzemních podlaží - počet nadzemních podlaží nad prvním podlažím. Použito pro výpočet daně. Povinné pole pro daňové přiznání. Příklad: přízemí = 0, přízemí + 1 patro = 1, atd.
     */
    pocPodlazpo: number;
    /**
     * Poměr výměry podlahových ploch podle § 9 odst. 3 zákona - podléhá-li nároku na osvobození pouze část stavby, uvede se poměr výměry podlahové plochy podléhající osvobození k celkové podlahové ploše. Hodnota v rozsahu 0.00 až 1.00.
     */
    pomVym92po?: number | null;
    /**
     * Poznámka pro daňové přiznání - upřesnění způsobu využití stavby (např. škola, hotel, obchod). Maximální délka 216 znaků.
     */
    pozn216?: string | null;
    /**
     * Podlahová plocha nebytového prostoru k podnikání nebo místnosti k ubytování v m² - celková výměra nebytového prostoru v budově obytného domu užívaného k podnikání. Vyplňuje se pouze u budov typu H (obytný dům).
     */
    vymPodnikpo?: number | null;
}

